// src/managerPortal/pages/NoAccess.js
import React from "react";
import { Link } from "react-router-dom";
import "../styles/NoAccess.css";

const NoAccess = () => {
    return (
        <div className="no-access-page">
            <div className="no-access-card">
                <h2 className="no-access-title">Access Denied</h2>
                <p className="no-access-message">
                    Oops! You must be signed in to view this page.
                </p>
                <Link to="/manager/signin" className="no-access-button">
                    Sign In
                </Link>
            </div>
        </div>
    );
};

export default NoAccess;
